import { QueryErrorBoundary } from '@components/errors/QueryErrorBoundary'
import { StudentMarkbookTab } from '@features/student-page/components/StudentMarkbookTab'
import { createFileRoute } from '@tanstack/react-router'
import { LoadingIndicator } from '@ui/LoadingIndicator'
import { Suspense } from 'react'
import { requireRouteAudience } from '@services/router/routeAccess'

export const Route = createFileRoute('/_layout/students/$studentNo/markbook')({
    beforeLoad: requireRouteAudience(['staff']),
    component: RouteComponent,
    staticData: {
        crumb: {
            label: 'Markbook',
        }
    }
})

function RouteComponent() {

    const { studentNo } = Route.useParams()

    return (
        <QueryErrorBoundary title='Failed to load student review information'>
            <Suspense fallback={<LoadingIndicator resource='review information'/>}>
                <StudentMarkbookTab studentNo={studentNo} />
            </Suspense>
        </QueryErrorBoundary>
    )
}
